import { showGlobalLoaderType, hideGlobalLoaderType } from './NavMenu';
import HttpUtil from '../util/HttpUtil';

const fetchFiltersType = "FETCH_CLIENT_FILTERS";

const initialState = {
    filters: null
};

export const actionCreators = {
    fetchFilters: () => async (dispatch, getState) => {
        HttpUtil.fetchGet("api/Requests/GetFilters", {}, true,
            data => {
                dispatch({ type: fetchFiltersType, filters: data });
            }
        );
    },
    showLoader: () => ({ type: showGlobalLoaderType }),
    stopLoader: () => ({ type: hideGlobalLoaderType })
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === fetchFiltersType) {
        return {
            ...state,
            filters: action.filters
        };
    }

    return state;
};
